import { Injectable } from '@angular/core';
import { IAccessContext } from '../../interfaces';
import { FeaturesType } from '../../models/features';

@Injectable({
  providedIn: 'root',
})
export class AccessContextService implements IAccessContext {
  canAccess(
    userModules: FeaturesType[],
    moduleToAccess: FeaturesType
  ): boolean {
    return !!userModules.find(userModule => userModule === moduleToAccess);
  }
}
